export default __webpack_public_path__ + "static/media/pil.89c03dbb.jpg";